import React from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import List from '../../list/list'
import ListExpandable from '../../list/list-expandable'
import Text from '../../form/form-text'
import DatePicker from '../../form/form-date-time-picker'
import Select from '../../form/form-select'

class ModuleTvGridHp extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            data: this.props,
            disabled: this.props.disabled
        }
        this.i18n = 'app.modules.components.'
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({disabled: nextProps.disabled})
    }

    render() {
        let { gridButtonName, liveTimeslotTeaser, otherTimeslotTeaser, replayButtonName, title } = this.state.data;
        let { disabled } = this.state;

        return <div className="module-tvGridMeta">
            <Text disabled={disabled} label={'app.title'} value={title} />
            <Text disabled={disabled} label={this.i18n + 'gridButtonName'} value={gridButtonName} />
            <Text disabled={disabled} label={this.i18n + 'liveTimeslotTeaser'} value={liveTimeslotTeaser} />
            <Text disabled={disabled} label={this.i18n + 'otherTimeslotTeaser'} value={otherTimeslotTeaser} />
            <Text disabled={disabled} label={this.i18n + 'replayButtonName'} value={replayButtonName} />
        </div>;
    }
}

ModuleTvGridHp.propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool, // souhld be .isRequired,
    isCustom: PropTypes.bool, // souhld be .isRequired,
    gridButtonName: PropTypes.string,
    liveTimeslotTeaser: PropTypes.string,
    otherTimeslotTeaser: PropTypes.string,
    replayButtonName: PropTypes.string,
    title: PropTypes.string,
}

export default ModuleTvGridHp;

